import {
    Container,
    Paper,
    Typography,
    Box,
    Button,
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio,
    Checkbox,
    FormGroup,
    FormHelperText
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
export default function SkillsAndCertificatesForm({

    data,

    errors,

    handleChange,
    
    handleCheckboxChange,

    onBack,

    onContinue

}) {

    return (

            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >

                <Typography variant="h4" gutterBottom>
                    Skills &amp; Certificates
                </Typography>
                <Typography sx={{ mb: 4, color: "rgba(0,0,0,0.6)", fontStyle: "italic"}}>
                    Please note: you will need to upload copies of these cards and certificates at the next stage of your onboarding.
                </Typography>

                <Box
                    sx={{
                        display: "grid",
                        gap: 3
                    }}
                >

                    {/* cscsSkillsCard */}

                    <FormControl error={!!errors.cscsSkillsCard}>
                        <FormLabel sx={{color: "rgba(0,0,0,1)"}}>Do you have a CSCS Card?</FormLabel>
                        <RadioGroup
                            row
                            name="cscsSkillsCard"
                            value={data.cscsSkillsCard}
                            onChange={handleChange}
                        >
                        <FormControlLabel
                            value="true"
                            control={<Radio />}
                            label="Yes"
                        />
                        <FormControlLabel
                            value="false"
                            control={<Radio />}
                            label="No"
                        />
                        </RadioGroup>
                        {
                            errors.cscsSkillsCard &&
                            <Typography color="error" variant="caption">
                                {errors.cscsSkillsCard}
                            </Typography>
                        }
                    </FormControl>
                </Box>

                {
                    data.paymentFrequency === "Monthly" && (
                    <>
                    <Box sx={{ display: "grid", gap: 3 }}>
                        {/* firstAid */}
                        <FormControl error={!!errors.firstAid}>
                            <FormLabel sx={{color: "rgba(0,0,0,1)"}}>Do you have a current First Aid at Work Certificate?</FormLabel>
                            <RadioGroup
                                row
                                name="firstAid"
                                value={data.firstAid}
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Yes"
                                />
                                <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="No"
                                />
                            </RadioGroup>
                            {
                                errors.firstAid &&
                                <Typography color="error" variant="caption">
                                    {errors.firstAid}
                                </Typography>
                            }
                        </FormControl>
                    </Box>
                    <Box sx={{ display: "grid", gap: 3 }}>
                        {/* otherTrainingCertificates */}
                        <FormControl error={!!errors.otherTrainingCertificates}>
                            <FormLabel sx={{color: "rgba(0,0,0,1)"}}>Do you have any other training certificates or qualifications relevant to your job?</FormLabel>
                            <RadioGroup
                                row
                                name="otherTrainingCertificates"
                                value={data.otherTrainingCertificates}
                                onChange={handleChange}
                            >
                                <FormControlLabel
                                    value="true"
                                    control={<Radio />}
                                    label="Yes"
                                />
                                <FormControlLabel
                                    value="false"
                                    control={<Radio />}
                                    label="No"
                                />
                            </RadioGroup>
                            {
                                errors.otherTrainingCertificates &&
                                <Typography color="error" variant="caption">
                                    {errors.otherTrainingCertificates}
                                </Typography>
                            }
                        </FormControl>
                    </Box>
                </>

                    )
                }
                {
                    data.paymentFrequency === "Fortnightly" && (
                    <>
                        <Box sx={{ mb: 4 }}>

                            <Typography
                                variant="h6"
                                gutterBottom
                            >

                                Indicate below which of the following you have been trained on.

                            </Typography>

                            <Typography
                                variant="body2"
                                sx={{ mb: 2 }}
                            >

                                Select all that apply.

                            </Typography>


                            <FormGroup>

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="nvq"
                                            checked={data.nvq}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="NVQ Qualification"

                                />

                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="pasmaScaffold"
                                            checked={data.pasmaScaffold}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="PASMA Scaffold"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="ipaf1b"
                                            checked={data.ipaf1b}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="IPAF (1B)"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="ipaf3a3b"
                                            checked={data.ipaf3a3b}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="IPAF (3A & 3B)"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="ipafHarness"
                                            checked={data.ipafHarness}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="IPAF (Harness)"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="ipafPav"
                                            checked={data.ipafPav}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="IPAF PAV"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="sssts"
                                            checked={data.sssts}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="SSSTS"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="abrasiveWheels"
                                            checked={data.abrasiveWheels}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="Abrasive Wheels"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="cpcsSkillsCard"
                                            checked={data.cpcsSkillsCard}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="CPCS"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="paslode"
                                            checked={data.paslode}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="PASLODE"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="manualHandling"
                                            checked={data.manualHandling}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="Manual Handling"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="hilti"
                                            checked={data.hilti}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="Hilti"

                                />
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="other"
                                            checked={data.other}
                                            onChange={handleCheckboxChange}
                                        />
                                    }
                                    label="Other"

                                />

                            </FormGroup>


                            {
                                errors.loanPlans && (

                                    <FormHelperText error>

                                        {errors.loanPlans}

                                    </FormHelperText>

                                )
                            }

                        </Box>
                    </>

                    )
                }
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 5
                    }}
                >

                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>

                </Box>

            </Paper>

    );

}